/**
 * 比赛时间配置
 * 默认值作为兜底，运行时从 public/config.json 的 contestTime 字段读取
 */
function parseDate(str) {
  const d = new Date(str)
  const y = d.getFullYear()
  const m = d.getMonth() + 1
  const day = d.getDate()
  const hh = String(d.getHours()).padStart(2, '0')
  return {
    num: parseInt(`${y}${String(m).padStart(2, '0')}${String(day).padStart(2, '0')}${hh}`),
    display: `${y}年${m}月${day}日`,
  }
}

function buildConfig(enrollStart, enrollEnd) {
  const start = parseDate(enrollStart)
  const end = parseDate(enrollEnd)
  const closeDate = new Date(enrollEnd)
  closeDate.setDate(closeDate.getDate() - 1)
  const closeDisplay = `${closeDate.getFullYear()}年${closeDate.getMonth() + 1}月${closeDate.getDate()}日`

  return {
    enrollStart,
    enrollEnd,
    enrollStartNum: start.num,
    enrollEndNum: end.num,
    enrollStartDisplay: start.display,
    enrollCloseDisplay: closeDisplay,
    enrollEndDisplay: end.display,
  }
}

// 默认值（兜底）
const contestConfig = buildConfig('2026/06/15 00:00:00', '2026/07/01 00:00:00')

/**
 * 从 config.json 的 contestTime 字段更新配置
 */
export function updateFromJson(contestTime) {
  if (contestTime && contestTime.enrollStart && contestTime.enrollEnd) {
    Object.assign(contestConfig, buildConfig(contestTime.enrollStart, contestTime.enrollEnd))
  }
}

export default contestConfig
